import { createContext, ReactNode, useContext } from "react";

import { useFilterRoomType } from "./filter-room-type.hook";

const FilterRoomTypeContext = createContext(
  {} as ReturnType<typeof useFilterRoomType>
);
export function useFilterRoomTypeContext() {
  return useContext(FilterRoomTypeContext);
}

interface FilterRoomTypeProviderProps {
  children: ReactNode;
}
export function FilterRoomTypeProvider({
  children,
}: FilterRoomTypeProviderProps) {
  return (
    <FilterRoomTypeContext.Provider value={useFilterRoomType()}>
      {children}
    </FilterRoomTypeContext.Provider>
  );
}